import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import { SitePublico } from "./components/SitePublico";
import { OrcamentoPublico } from "./components/OrcamentoPublico";

// No Electron (protocolo file://), BrowserRouter usa a History API do
// navegador — e um <Navigate to="/" replace/> (a rota "*" abaixo) acaba
// chamando history.replaceState("/"), que no Windows o Chromium resolve
// pra RAIZ DO DRIVE ("file:///F:/") em vez da pasta do app. Isso quebra a
// URL base do documento pra sempre: os assets (JS/CSS com caminho
// relativo) passam a ser buscados no lugar errado e o React nunca chega a
// montar — tela em branco/escura pra sempre, mesmo tendo carregado a
// página certa inicialmente. HashRouter usa só o fragmento (#/rota), que
// nunca toca a URL base — funciona igual nos outros ambientes (web/app
// mobile continuam de BrowserRouter, com links normais).
const isElectron = typeof window !== "undefined" && !!window.electronAPI?.isElectron;
const Router = isElectron ? HashRouter : BrowserRouter;

export default function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/loja/:vendedorId" element={<SitePublico />} />
        {/* Link novo, de segmento único (slug com o nome do cliente) — o que
            gerarLinkOrcamento gera hoje. O de dois segmentos abaixo é o
            formato antigo (uid+id), mantido só pra links já mandados antes
            dessa mudança continuarem abrindo. */}
        <Route path="/orcamento/:slug" element={<OrcamentoPublico />} />
        <Route path="/orcamento/:vendedorId/:orcamentoId" element={<OrcamentoPublico />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
